import { connect } from 'react-redux'
import {
  getProjects,
} from 'reduxpath/ducks/Project/List'

import List from './units'

const mapStateToProps = state => ({
  data: state.ProjectList.data,
  orderStatus: state.ProjectList.orderStatus,
  isLoading: state.ProjectList.isLoading,
  projectStatus: state.ProjectList.projectStatus,
  searchProjectBrand: state.ProjectList.searchProjectBrand,
  projectCountry: state.ProjectList.projectCountry,
  sortBy: state.ProjectList.sortBy,
  isOrganicOnly: state.ProjectList.isOrganicOnly,
  isManagedOnly: state.ProjectList.isManagedOnly,
})

const mapDispatchToProps = dispatch => ({
  handlePageChange(projectStatus, searchProjectBrand, projectCountry, sortBy, isOrganicOnly, isManagedOnly) {
    return (key) => {
      const limit = 10
      const qs = {
        sort: `${sortBy} DESC`,
        limit,
        skip: key.selected * limit,
        where: {
          or: [
            { name: { like: `%${searchProjectBrand}%` } },
            { brand: { like: `%${searchProjectBrand}%` } },
            { firstName: { like: `%${searchProjectBrand}%` } },
            { email: { like: `${searchProjectBrand}%` } }
          ],
        },
      }

      if (isOrganicOnly) {
        qs.where.isOrganic = true
      }
      if (isManagedOnly) {
        qs.where.isManaged = true
      }
      if (searchProjectBrand === qs.where.name) {
        qs.where.name = searchProjectBrand
      } else if (searchProjectBrand === qs.where.brand) {
        qs.where.brand = searchProjectBrand
      }

      if (projectStatus) {
        qs.where.status = projectStatus
      }
      if (projectCountry) {
        qs.where.country = projectCountry
      }

      dispatch(getProjects(qs))
    }
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(List)
